import { render, staticRenderFns } from "./proposal-modal.vue?vue&type=template&id=2fc4a110&"
import script from "./proposal-modal.vue?vue&type=script&lang=js&"
export * from "./proposal-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports